export const INITIALIZE_VIEW = "INITIALIZE_VIEW"
export const FETCH_REVIEWS_START = "FETCH_REVIEWS_START"
export const FETCH_REVIEWS_SUCCESS = "FETCH_REVIEWS_SUCCESS"
export const FETCH_REVIEWS_FAILURE = "FETCH_REVIEWS_FAILURE"

const initialState = {
  companyId: null,
  productId: null,
  reviews: {
    model: null,
    fetchDone: false,
    fetchLoading: true,
    fetchFailed: false,
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_VIEW:
      return {
        ...state,
        companyId: action.companyId,
        productId: action.productId,
      }

    case FETCH_REVIEWS_START:
      return {
        ...state,
        slots: {
          ...state.reviews,
          fetchLoading: true,
          fetchFailed: false,
        }
      }

    case FETCH_REVIEWS_SUCCESS:
      return {
        ...state,
        reviews: {
          ...state.reviews,
          model: action.data.reviews,
          rating: action.data.rating,
          fetchDone: true,
          fetchFailed: false,
          fetchLoading: false,
        }
      }

    case FETCH_REVIEWS_FAILURE:
      return {
        ...state,
        reviews: {
          ...state.reviews,
          fetchFailed: true,
          fetchLoading: false,
        }
      }

    default:
      return state
  }
}

export function initializeView({ companyId, productId }) {
  return dispatch => {
    dispatch({ type: INITIALIZE_VIEW, companyId, productId })
  }
}

export function fetchReviews() {
  return (dispatch, getState) => {
    const { companyId, productId } = getState()
    dispatch({ type: FETCH_REVIEWS_START })
    return st.resources.reviews.findAll({
      company_id: companyId || undefined,
      product_id: productId || undefined,
      limit: 3,
    }).then(
      data => dispatch({ type: FETCH_REVIEWS_SUCCESS, data }),
      error => dispatch({ type: FETCH_REVIEWS_FAILURE, error }),
    )
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/ReviewsListWidget/duck.js